<template>
<div class="heritage-division">
    <div v-if="role === 'admin' && loaded && !hasKintone" class="text-center mt1">
        <p>相続人情報又は、財産情報が連携されていません。</p>
    </div>
    <div v-else-if="!hasKintone || role === 'client' && !hasDivisionDetail" class="text-center mt1">
        財産情報が登録されていません。
    </div>
    <div v-else-if="role === 'admin' && !hasDivisionDetail" class="mt1">
        <el-button @click="createInitialPlan">初回分割案の作成</el-button>
    </div>
    <div v-else>
        <div v-if="hasDivisionDetail">
            <div class="isan-btns mt2">
                <button v-for="(s) in simulations" :key="s.id"
                    @click="handleSelectDivisionDetail(s.id)"
                    v-bind:class="['btn__default mr1 div-update-notice', s.id === simulationId ? 'el-button' : '']"
                    v-bind:disabled="s.id === simulationId">
                        <img height="12px" src="@/images/new.png" :class="updateNoticePlanId[s.id] ? 'img-update-notice': 'img-update-notice-none'">
                        {{s.id === 0 ? '初期分割案' : s.id === -1 ? '新規分割案' : `分割案${s.id}`}}
                    </button>
            </div>
            <div class="border-box isan-info mt2">
                <div class="isan-info-item d-flex">
                    <div class="isan-info-item-title mr-auto">
                        <strong>相続人</strong>
                    </div>
                    <div class="isan-info-item-cnt">
                        <div class="mr1-pc" v-for="heir in heirs" :key="heir.id">{{heir.relationship}}：{{heir.name}}</div>
                    </div>
                </div>
            </div>
            <div class="border-box mt1">
                <div class="d-flex">
                    <div class="mr-auto">
                        <strong>分割案作成者</strong>
                    </div>
                    <div>
                        <div>{{simulationMember.lastName}} {{simulationMember.firstName}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="hasDivisionDetail" class="mt1 text-center">
            <button v-if="canAddDivisionDetail" class="btn__default margin btn--background-green gtm_bunkatu_new_bunkatu" @click="newDivisionDetail()" :disabled="isEditAbleSimulation || disableByPerm">新しく分割案を作成する</button>
            <button v-if="isDivisionDetailOwner" class="btn__default margin btn--background-red gtm_bunkatu_henkou_bunkatu" @click="editAbleSimulation" :disabled="isEditAbleSimulation || disableByPerm">分割案を修正する</button>
            <button v-if="simulationId > 0 && isDivisionDetailOwner" class="btn__default margin btn--background-gray gtm_bunkatu_sakujo_bunkatu" @click="removeDivisionDetail(simulationId)" :disabled="isEditAbleSimulation || disableByPerm">分割案を削除する</button>
            <button v-if="this.role === 'admin'" class="btn__default margin el-button--primary" @click="handleDownload">ダウンロード</button>
        </div>
        <div v-if="isDivisionDetailOwner && simulationId != 0">
            <div class="border-box mt2">
                <div class="mr-auto">
                    <strong>分割案公開先</strong>
                </div>
                <p class="text-center">
                    <el-checkbox-group v-model="disclosure">
                        <el-checkbox v-for="m in viewSelectMembers" :key="m.id" :label="m.id" :disabled="!isEditAbleSimulation || disableByPerm">
                            {{m.lastName}} {{m.firstName}}
                        </el-checkbox>
                        <el-checkbox v-if="simulationMemberId != 0" :label="0" :disabled="!isEditAbleSimulation || disableByPerm">レガシィ</el-checkbox>
                    </el-checkbox-group>
                </p>
            </div>
        </div>
        <div class="mt1 text-center division-button" v-if="isEditAbleSimulation">
            <el-button @click="cancelSimulation" :disabled="disableByPerm">キャンセル</el-button>
            <el-button class="gtm_bunkatu_hozonup_bunkatu" @click="saveSimulation" :disabled="disableByPerm"><span class="gtm_bunkatu_hozonup_bunkatu">保存</span></el-button>
        </div>
        <div class="mt1" v-if="isShowDivisionDetail">
            <div class="tab-wrap mt1">
                <ul class="flex">
                    <li class="ml-auto">{{simulationDetail.updatedAt|formatDate}}</li>
                </ul>
                <ul class="flex" id="total-table-tabs">
                    <li v-bind:class="`tab-btn ${tabTotal === 'by_total_property'? 'current' : ''}`" @click="showTotalTab('by_total_property')">総計</li>
                    <li v-bind:class="`tab-btn ${tabTotal === 'by_total_summary'? 'current' : ''}`" @click="showTotalTab('by_total_summary')">個人</li>
                    <li v-bind:class="`tab-btn ${tabTotal === 'by_total_asset'? 'current' : ''}`" @click="showTotalTab('by_total_asset')">財産</li>
                    <li v-bind:class="`tab-btn ${tabTotal === 'by_total_debpt'? 'current' : ''}`" @click="showTotalTab('by_total_debpt')">債務</li>
                </ul>
            </div>
            <div class="tab-contents" v-if="tabTotal === 'by_total_summary'">
                <div class="table-responsive">
                    <table class="table table-mobile">
                        <colgroup>
                            <col style="width: 45%">
                            <col style="width: 20%">
                            <col style="width: 35%">
                        </colgroup>
                        <tr>
                            <th>総計<i class="fas ml1"></i></th>
                            <th class="text-right" colspan="2">{{totalInheritance | numberWithDebt}}</th>
                        </tr>
                        <tr v-for="(detail, ai) in divisionGeneral" :key="detail.id">
                            <td><a class="scroll cursor-pointer" @click="scrollDetail('individual', ai, 'name')">{{detail.name}}</a></td>
                            <td class="text-right"> <div class="text-center-mobile">{{Math.floor(detail.inheritance / totalInheritance * 100)}}<small>%</small></div></td>
                            <td class="text-right"><a class="scroll cursor-pointer" @click="scrollDetail('individual', ai, 'amount')">{{detail.inheritance | numberWithDebt}}</a></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="tab-contents" v-if="tabTotal === 'by_total_debpt'">
                <div class="table-responsive">
                    <table class="table  table-mobile">
                        <colgroup>
                            <col style="width: 45%">
                            <col style="width: 20%">
                            <col style="width: 35%">
                        </colgroup>
                        <tr>
                            <th>債務<i class="fas ml1"></i></th>
                            <th class="text-right" colspan="2">{{totalDept | numberWithDebt}}</th>
                        </tr>
                        <tr v-for="detail in divisionGeneral" :key="detail.id">
                            <td>{{detail.name}}</td>
                            <td class="text-right"><div class="text-center-mobile">{{percentDiv(detail.dept, totalDept)}}<small>%</small> </div></td>
                            <td class="text-right">{{detail.dept | numberWithDebt}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="tab-contents" v-if="tabTotal === 'by_total_asset'">
                <div class="table-responsive">
                    <table class="table table-mobile">
                        <colgroup>
                            <col style="width: 45%">
                            <col style="width: 20%">
                            <col style="width: 35%">
                        </colgroup>
                        <tr>
                            <th id="total-assets">財産<i class="fas ml1"></i></th>
                            <th id="total-assets-value" class="text-right" colspan="2">{{totalAsset | numberWithDebt}}</th>
                        </tr>
                        <tr v-for="detail in divisionGeneral" :key="detail.id">
                            <td>{{detail.name}}</td>
                            <td class="text-right"> <div class="text-center-mobile" >{{percentDiv(detail.asset, totalAsset)}}<small>%</small> </div></td>
                            <td class="text-right">{{detail.asset| numberWithDebt}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="tab-contents" v-if="tabTotal === 'by_total_property'">
                <div class="table-responsive">
                    <table class="table table-mobile">
                        <colgroup>
                            <col style="width: 45%">
                            <col style="width: 20%">
                            <col style="width: 35%">
                        </colgroup>
                        <tr>
                            <th>総計<i class="fas ml1"></i></th>
                            <th class="text-right" colspan="2">{{totalInheritance | numberWithDebt}}</th>
                        </tr>
                        <tr v-for="(individualTypeDetail, ai) in simulationIndividualTypeDetail" :key="`assetTypeDetailContainer_${ai}`">
                            <td><a class="scroll cursor-pointer" @click="scrollDetail('asset', ai, 'name')">{{individualTypeDetail.name}}</a></td>
                            <td class="text-right" colspan="2"><a class="scroll cursor-pointer" @click="scrollDetail('asset', ai, 'amount')">{{individualTypeDetail.amount | numberWithDebt}}</a></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <el-form :disabled="!isEditAbleSimulation">
        <div class="tab-wrap mt2">
            <ul class="flex">
                <li v-bind:class="`tab-btn ${tab === 'by_asset'? 'current' : ''}`"
                    @click="showTab('by_asset')">資産別</li>
                <li v-bind:class="`tab-btn ${tab === 'by_individual'? 'current' : ''}`"
                    @click="showTab('by_individual')">個人別</li>
            </ul>
            <div class="tab-contents" v-if="tab === 'by_individual'">
                <div class="table-responsive">
                    <div v-for="(assetTypeDetail, ai) in simulationAssetTypeDetail"
                    :key="`assetTypeDetail_${ai}`">
                        <table :key="`assetTypeDetail_${ai}`"
                        v-bind:class="['table', 'table-mobile' , ai > 0 ? 'mt1' : '']">
                        <colgroup>
                            <col style="width: 5%">
                            <col style="width: 40%">
                            <col style="width: 20%">
                            <col style="width: 35%">
                        </colgroup>
                        <!-- 個人別 -->
                        <tr>
                            <th colspan="2" :id="`individual_${ai}_name`">{{assetTypeDetail.name}}<i class="fas ml1"></i></th>
                            <th :id="`individual_${ai}_amount`" class="text-right" colspan="2">{{assetTypeDetail.amount | numberWithDebt}}</th>
                        </tr>
                        <!-- グループ -->
                        <template v-for="(largeItem, aig) in assetTypeDetail.largeItems">
                            <tr
                               :key="`assetTypeDetail_${aig}`"
                               v-bind:class="largeItem.details && largeItem.details.length > 0 ? 'cursor-pointer' : ''"
                               @click="showIndividualLargeItem(largeItem.key)">
                                <td colspan="2">{{largeItem.large_item_value}} <i class="fas fa-chevron-right ml1"></i></td>
                                <td></td>
                                <td class="text-right" >{{largeItem.amount | numberWithDebt}}</td>
                            </tr>
                            <template v-if="viewShowIndividualLargeItem[largeItem.key]">
                                <tr v-for="(detail, dIndex) in largeItem.details" :key="detail.id">
                                    <td v-bind:class="['transparent', 'border-left-0', dIndex !== largeItem.details.length - 1 || aig === assetTypeDetail.largeItems.length - 1 ? 'border-bottom-0' : '' ]"></td>
                                    <td class="pl2">{{detail.section_value}} {{detail.items_value}} {{detail.etc}}</td>
                                    <td>
                                        <div v-if="!isEditAbleSimulation" class="text-right text-center-mobile" >{{percent[detail.id] }}<small>%</small></div>
                                        <div v-if="isEditAbleSimulation" class="d-flex align-items-center ">
                                            <el-input type="number" min="0" max="100" v-model="percent[detail.id]" class="percent"
                                                @input="changeInputPercent($event, detail.id)"></el-input>
                                            <small>%</small>
                                        </div>
                                    </td>
                                    <td>
                                      <div v-if="!isEditAbleSimulation" class="text-right" >{{detail.debt_flag ? - amount[detail.id] : amount[detail.id] | numberWithDebt}}</div>
                                      <div v-if="isEditAbleSimulation" class="d-flex align-items-center float-right">
                                          <div class="mr-3">{{detail.debt_flag ? '▲' : ''}}</div>
                                          <div>
                                              <number-input :id="detail.id" v-model="amount[detail.id]" @input="changeInputAmount($event, detail.id)"></number-input>
                                              <div v-if="alertAmount[detail.id].alert && showWarningAmount" class="text-alert">{{alertAmount[detail.id].large_item_value}}の合計が一致していません。</div>
                                          </div>
                                      </div>
                                    </td>
                                </tr>
                            </template>
                         </template>
                    </table>
                    <p class="mt1 text-right">
                        <button class="btn__default btn--background-red" @click.prevent="moveToTotalTab">総計へ戻る　<i class="fas fa-arrow-up"></i></button>
                    </p>
                    </div>
                </div>
            </div>
            <div class="tab-contents current" v-if="tab === 'by_asset'">
                <div class="table-responsive">
                    <div v-for="(individualTypeDetail, ai) in simulationIndividualTypeDetail"
                        :key="`assetTypeDetailContainer_${ai}`">
                        <table
                            :key="`assetTypeDetail_${ai}`"
                            v-bind:class="['table', 'table-mobile', ai > 0 ? 'mt1' : '']">
                            <colgroup>
                                <col style="width: 5%">
                                <col style="width: 40%">
                                <col style="width: 20%">
                                <col style="width: 35%">
                            </colgroup>
                            <tr v-bind:class="isEditAbleSimulation &&　heirs && heirs.length > 0 ? 'cursor-pointer' : ''"
                                @click="$set(classificationPercent, `${ai}`, !classificationPercent[ai])">
                                <th colspan="2" :id="`asset_${ai}_name`">{{individualTypeDetail.name}}<div class="btn__default ml1 btn--background-red" v-if="isEditAbleSimulation &&　heirs && heirs.length > 0">一括入力</div></th>
                                <th colspan="2" :id="`asset_${ai}_amount`" class="text-right">{{individualTypeDetail.amount | numberWithDebt}}</th>
                            </tr>
                            <template v-if="isEditAbleSimulation && classificationPercent[ai]">
                            <tr v-for="h in heirs" :key="h.id">
                                <td class="transparent border-left-0 border-bottom-0"></td>
                                <td class="pl2">{{h.name}}</td>
                                <td class="cell-percent">
                                    <div class="d-flex align-items-center">
                                        <el-input type="number" min="0" max="100" class="percent" v-model="classificationPercent[ai + '_' + h.id]" @input="changeInputClassificationPercent($event, ai, h.id)"></el-input>
                                        <small>%</small>
                                    </div>
                                </td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td class="transparent border-left-0"></td>
                                <td colspan="3"><div class="text-center">
                                    <button style="white-space: normal;" class="btn__default btn--background-red" @click.prevent="setIndividualPercent(ai)">全ての{{individualTypeDetail.name}}に割合を反映する</button>
                                </div></td>
                            </tr>
                            </template>
                            <template v-for="(item, iIndex) in individualTypeDetail.items">
                            <tr :key="item.key"
                                v-bind:class="item.heirsDetail && item.heirsDetail.length > 0 ? 'cursor-pointer' : ''"
                                @click="showAssetHeirDetail(item.key)">
                                <td colspan="2">{{item.section_value}} {{item.items_value}} {{item.etc}} <i class="fas fa-chevron-right ml1"></i></td>
                                <td></td>
                                <td class="text-right">{{item.amount | numberWithDebt}}</td>
                            </tr>
                            <template v-if="viewShowAssetHeir[item.key]">
                            <tr v-for="(h, hIndex) in item.heirsDetail" :key="h.id">
                                <td v-bind:class="['transparent', 'border-left-0', hIndex !== item.heirsDetail.length - 1 || iIndex === individualTypeDetail.items.length - 1 ? 'border-bottom-0' : '' ]"></td>
                                <td class="pl2 cell-name">{{h.name}}</td>
                                <td class="cell-percent">
                                    <div v-if="!isEditAbleSimulation" class="text-right text-center-mobile" >{{percent[h.id] }}<small>%</small></div>
                                    <div v-if="isEditAbleSimulation" class="d-flex align-items-center">
                                        <el-input type="number" min="0" max="100" v-model="percent[h.id]" class="percent"
                                            @input="changeInputPercent($event, h.id)"></el-input>
                                        <small>%</small>
                                    </div>
                                </td>
                                <td class="cell-amount">
                                    <div v-if="!isEditAbleSimulation" class="text-right" >{{h.debt_flag ? - amount[h.id] : amount[h.id] | numberWithDebt}}</div>
                                    <div v-if="isEditAbleSimulation" class="d-flex align-items-center  float-right">
                                    <div class="mr-3">{{h.debt_flag ? '▲' : ''}}</div>
                                        <div>
                                            <number-input :id="h.id" v-model="amount[h.id]" @input="changeInputAmount($event, h.id)"></number-input>
                                            <div v-if="alertAmount[h.id].alert && showWarningAmount" class="text-alert">{{alertAmount[h.id].large_item_value}}の合計が一致していません。</div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            </template>
                            </template>
                        </table>
                        <p class="mt1 text-right">
                            <button class="btn__default btn--background-red" @click.prevent="moveToTotalTab">総計へ戻る　<i class="fas fa-arrow-up"></i></button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        </el-form>
        <div class="mt1 text-center division-button" v-if="isEditAbleSimulation">
            <el-button @click="cancelSimulation" :disabled="disableByPerm">キャンセル</el-button>
            <el-button class="gtm_bunkatu_hozondown_bunkatu" @click="saveSimulation" :disabled="disableByPerm"><span class="gtm_bunkatu_hozondown_bunkatu">保存</span></el-button>
        </div>
    </div>
</div>
</template>
<script>
    import DivisionSimulationApi from '@/api/division-simulation'
    import UpdateNoticeApi from '@/api/update-notice/update-notice.js'
    import _ from 'lodash'
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import { MessageBox } from 'element-ui'
    import NumberInput from '../../../../components/common/NumberInput'
    import Papa from 'papaparse'
    export default {
    components: { NumberInput },
    props: ['ankenId', 'role'],
    data () {
        return {
            tab: 'by_asset',
            tabTotal: 'by_total_property',
            anken: [],
            members: [],
            viewSelectMembers: [],
            kintoneHeirs: [],
            kintoneHeirsMap: [],
            kintoneHeirsUpdatedAt: null,
            kintoneProperties: [],
            kintonePropertiesMap: [],
            kintonePropertiesUpdatedAt: null,
            kintoneKintoneAnkenId: null,
            heirs: [],
            heirsMap: [],
            heirsUpdatedAt: null,
            properties: [],
            propertiesMap: [],
            propertiesUpdatedAt: null,
            kintoneAnkenId: null,
            simulations: [],
            totalRecords: null,
            isShowDivisionDetail: false,
            viewShowAssetHeir: {},
            viewShowIndividualLargeItem: {},
            percent: {},
            amount: {},
            simulationIndividualTypeDetail: [],
            simulationAssetTypeDetail: [],
            simulationId: null,
            simulationMemberId: null,
            simulationMember: {},
            disclosure: [],
            isEditAbleSimulation: false,
            showWarningAmount: false,
            viewMappingGroup: {},
            simulationDetail: {
                data: [],
                updatedAt: null
            },
            loaded: false,
            updateNoticePlanId: {},
            classificationPercent: {}
        }
    },
    created () {
        this.loadData()
    },
    mounted () {
        this.getUpdateNotice()
    },
    methods: {
        loadData: async function () {
            const data = await DivisionSimulationApi.getDivisionSimulation(this.ankenId, true)
            this.anken = data.anken
            this.members = data.member ? Object.keys(data.member).map(key => ({ ...data.member[key], id: +key })) : []
            this.viewSelectMembers = this.role === 'admin' ? this.members : this.members.filter((m) => { return m.id !== this.currentUser.id })
            this.kintoneKintoneAnkenId = data.kintoneAnkenId
            this.kintoneHeirsMap = data.heirs || []
            this.kintoneHeirsUpdatedAt = data.heirsUpdatedAt
            this.$parent.heirsUpdatedAt = this.kintoneHeirsUpdatedAt
            this.kintoneHeirs = data.heirs ? Object.keys(data.heirs).map(key => ({ ...data.heirs[key], id: +key })) : []
            this.kintoneHeirs = _.orderBy(this.kintoneHeirs, ['relationship_id', 'name', 'relationship'], ['asc', 'asc', 'asc'])
            this.kintonePropertiesMap = data.properties || []
            this.kintonePropertiesUpdatedAt = data.propertiesUpdatedAt
            this.$parent.propertiesUpdatedAt = this.kintonePropertiesUpdatedAt
            const propertiesGroupMap = {}
            _.map(_.groupBy(this.kintonePropertiesMap, function (p) { return this.groupType(p) }.bind(this)), function (p, key) { propertiesGroupMap[key] = _.min(p, 'displayOrder').displayOrder })
            this.kintoneProperties = data.properties ? Object.keys(data.properties).map(key => ({ ...data.properties[key], id: +key, minDisplayOrder: propertiesGroupMap[this.groupType(data.properties[key])] })) : []
            this.kintoneProperties = _.orderBy(this.kintoneProperties, ['displayGroup', 'minDisplayOrder', 'displayOrder', 'displayDetail', 'details_num'], ['asc', 'asc', 'asc', 'asc', 'asc'])
            this.simulations = data.simulations ? Object.keys(data.simulations).map(key => ({ ...data.simulations[key], id: +key })) : []
            this.simulations = _.orderBy(this.simulations, ['id'], ['asc'])
            this.totalRecords = data.totalRecords ? +data.totalRecords : 0
            const defaultSimulation = this.simulations ? this.simulations.find(s => s.member_id === 0) : null
            if (defaultSimulation) this.showDivisionDetail(defaultSimulation.id)
            this.loaded = true
        },
        groupType: function (property) {
            return property.displayGroup + property.large_item_value
        },
        errorMessageBox: function (error, message) {
            const host = window.location.hostname
            const DOMAIN_ADMIN = process.env.VUE_APP_DOMAIN_ADMIN
            // ADMINでのMessageBoxの重複表示回避
            if (host !== DOMAIN_ADMIN || error.response.status < 500) {
              MessageBox({
                title: message,
                type: 'エラー',
                showClose: false,
                center: true
              })
            }
        },
        newDivisionDetail: async function () {
            try {
                const data = await DivisionSimulationApi.getDivisionSimulation(this.ankenId, false)
                this.simulations = data.simulations ? Object.keys(data.simulations).map(key => ({ ...data.simulations[key], id: +key })) : []
                this.simulations = _.orderBy(this.simulations, ['id'], ['asc'])
                this.totalRecords = data.totalRecords ? +data.totalRecords : 0
                if (this.totalRecords < 11) {
                    const resInitialPlan = await DivisionSimulationApi.getDivisionSimulationDetail(this.ankenId, 0)
                    this.simulations.push({ id: -1, member_id: this.role === 'admin' ? 0 : this.currentUser.id, disclosure: [] })
                    this.simulationMemberId = this.role === 'admin' ? 0 : this.currentUser.id
                    this.disclosure = resInitialPlan.disclosure
                    this.setSimulationDetail(-1, resInitialPlan)
                    this.editAbleSimulation()
                } else {
                    MessageBox({
                        title: '分割案の作成は、最大10件までとなります。',
                        type: 'エラー',
                        showClose: false,
                        center: true
                    })
                }
            } catch (e) {
                if (e.response.status === 400 && e.response.data.message != null) {
                    this.errorMessageBox(e, e.response.data.message)
                } else {
                    this.errorMessageBox(e, '分割案の取得に失敗しました。')
                }
            }
        },
        removeDivisionDetail: function (simulationId) {
            this.$confirm(`分割案${simulationId}`, '分割案を削除します。よろしいですか？', {
              confirmButtonText: '削除する',
              cancelButtonText: 'キャンセル',
              type: 'warning',
              showClose: false
            }).then(() => {
                DivisionSimulationApi.removeDivisionSimulationDetail(this.ankenId, simulationId).then(res => {
                    const data = res.data
                    this.simulations = data.simulations ? Object.keys(data.simulations).map(key => ({ ...data.simulations[key], id: +key })) : []
                    this.simulations = _.orderBy(this.simulations, ['id'], ['asc'])
                    this.totalRecords = data.totalRecords ? +data.totalRecords : 0
                    MessageBox({
                        title: '削除しました。',
                        showClose: true,
                        center: true,
                        confirmButtonClass: 'btn-msg-box'
                    })
                    setTimeout(() => { MessageBox.close() }, 2000)
                    this.showDivisionDetail(0)
                }).catch((e) => {
                    if (e.response.status === 400 && e.response.data.message != null) {
                        this.errorMessageBox(e, e.response.data.message)
                    } else {
                        this.errorMessageBox(e, '分割案の削除に失敗しました。')
                    }
                })
            }).catch(() => {})
        },
        saveDivisionDetail: async function (simulationId) {
            try {
                const res = await DivisionSimulationApi.putDivisionSimulationDetail(this.ankenId, this.simulationId, { kintoneAnkenId: this.kintoneAnkenId, details: this.simulationDetail.data, properties: this.propertiesMap, propertiesUpdatedAt: this.propertiesUpdatedAt, heirs: this.heirsMap, heirsUpdatedAt: this.heirsUpdatedAt, disclosure: this.disclosure })
                if (this.simulationId === -1) {
                    this.simulations.pop()
                    this.simulations.push({ id: res.id, member_id: this.simulationMemberId, disclosure: this.disclosure })
                    this.simulations = _.orderBy(this.simulations, ['id'], ['asc'])
                    this.simulationId = res.id
                    this.totalRecords++
                }
                this.isEditAbleSimulation = false
            } catch (e) {
                if (e.response.status === 400 && e.response.data.message != null) {
                    this.errorMessageBox(e, e.response.data.message)
                } else {
                    this.errorMessageBox(e, this.simulationId === -1 ? '分割案の作成は、最大10件までとなります。' : '分割案の保存に失敗しました。')
                }
            }
        },
        showDivisionDetail: async function (simulationId) {
            try {
                const res = await DivisionSimulationApi.getDivisionSimulationDetail(this.ankenId, simulationId)
                this.simulationDetail.updatedAt = res.updatedAt
                this.simulationMemberId = res.member_id
                this.disclosure = res.disclosure
                this.setSimulationDetail(simulationId, res)
                this.isEditAbleSimulation = false
            } catch (e) {
                this.errorMessageBox(e, '分割案の取得に失敗しました。')
            }
        },
        setSimulationDetail: function (simulationId, data) {
            this.kintoneAnkenId = data.kintoneAnkenId
            if (data.heirs) {
                this.heirsMap = data.heirs
                this.heirsUpdatedAt = data.heirsUpdatedAt
                this.heirs = data.heirs ? Object.keys(data.heirs).map(key => ({ ...data.heirs[key], id: +key })) : []
                this.heirs = _.orderBy(this.heirs, ['relationship_id', 'name', 'relationship'], ['asc', 'asc', 'asc'])
            } else {
                this.heirsMap = this.kintoneHeirsMap
                this.heirsUpdatedAt = this.kintoneHeirsUpdatedAt
                this.heirs = this.kintoneHeirs
            }
            if (data.properties) {
                this.propertiesMap = data.properties
                this.propertiesUpdatedAt = data.propertiesUpdatedAt
                const propertiesGroupMap = {}
                _.map(_.groupBy(this.propertiesMap, function (p) { return this.groupType(p) }.bind(this)), function (p, key) { propertiesGroupMap[key] = _.min(p, 'displayOrder').displayOrder })
                this.properties = data.properties ? Object.keys(data.properties).map(key => ({ ...data.properties[key], id: +key, minDisplayOrder: propertiesGroupMap[this.groupType(data.properties[key])] })) : []
                this.properties = _.orderBy(this.properties, ['displayGroup', 'minDisplayOrder', 'displayOrder', 'displayDetail', 'details_num'], ['asc', 'asc', 'asc', 'asc', 'asc'])
            } else {
                this.propertiesMap = this.kintonePropertiesMap
                this.propertiesUpdatedAt = this.kintonePropertiesUpdatedAt
                this.properties = this.kintoneProperties
            }
            const detail = this.complementDetailsDefault(data.details)
            this.simulationDetail.data = detail
            this.simulationId = +simulationId
            this.$set(this.updateNoticePlanId, this.simulationId, false)
            this.getUpdateNotice()
            this.isShowDivisionDetail = true
            this.clearView()
        },
        showAssetHeirDetail: function (itemId) {
            this.$set(this.viewShowAssetHeir, itemId, !this.viewShowAssetHeir[itemId])
        },
        showIndividualLargeItem: function (itemId) {
            this.$set(this.viewShowIndividualLargeItem, itemId, !this.viewShowIndividualLargeItem[itemId])
        },
        changeInputPercent (value, id) {
            // check if value if greater than 100
            value = Math.min(value, 100)
            this.percent[id] = value
            const simulation = this.simulationDetail.data.find(s => +s.property_id === +id.split('_')[1] && +s.heir_id === +id.split('_')[2])
            this.$set(simulation, 'ratio', +value)

            const property = this.properties.find(p => +p.id === +simulation.property_id)
            const amount = Math.floor(value * property.amount / 100)
            this.$set(simulation, 'amount', amount)
        },
        changeInputAmount (value, id) {
            const simulation = this.simulationDetail.data.find(p => +p.property_id === +id.split('_')[1] && +p.heir_id === +id.split('_')[2])
            this.$set(simulation, 'amount', +value)
            const property = this.properties.find(p => +p.id === +simulation.property_id)
            const ratio = this.percentDiv(value, property.amount)
            this.$set(simulation, 'ratio', ratio)
        },
        makeSimulationIndividualTypeDetail: function () {
            const propertiesGroup = _.groupBy(this.properties, function (p) { return this.groupType(p) }.bind(this))
            const mapedDetails = this.simulationDetail.data.reduce((result, item) => {
                var heirs = result[item.heir_id] = result[item.heir_id] || {}
                heirs[item.property_id] = heirs[item.property_id] || item
                return result
            }, {})
            this.simulationIndividualTypeDetail = Object.keys(propertiesGroup).map(key => {
                let largeItemValue = ''
                let items = []
                let totalAmount = 0
                for (const property of propertiesGroup[key]) {
                    largeItemValue = property.large_item_value
                    let heirsDetail = []
                    const key = `property_${property.id}`
                    for (const heir of this.heirs) {
                        let detail = mapedDetails[heir.id][property.id]
                        const id = `property_${property.id}_${heir.id}`
                        this.setViewMappingGroup(id, key)
                        heirsDetail.push({
                            id,
                            relationship: heir.relationship,
                            name: heir.name,
                            ratio: detail.ratio,
                            amount: detail.amount,
                            debt_flag: property.debt_flag
                        })
                    }
                    items.push({
                        key,
                        items_value: property.items_value,
                        section_value: property.section_value,
                        etc: property.etc,
                        amount: property.debt_flag ? 0 - property.amount : property.amount,
                        debt_flag: property.debt_flag,
                        heirsDetail
                    })
                    if (property.debt_flag) {
                        totalAmount -= property.amount
                    } else {
                        totalAmount += property.amount
                    }
                }
                return {
                    items,
                    name: largeItemValue,
                    amount: totalAmount
                }
            })
        },
        makeSimulationAssetTypeDetail: function () {
            const propertiesGroup = _.groupBy(this.properties, function (p) { return this.groupType(p) }.bind(this))
            const mapedDetails = this.simulationDetail.data.reduce((result, item) => {
                var heirs = result[item.heir_id] = result[item.heir_id] || {}
                heirs[item.property_id] = heirs[item.property_id] || item
                return result
            }, {})
            // 人別
            this.simulationAssetTypeDetail = this.heirs.map(heir => {
                const largeItems = []
                let amount = 0
                // 大項目別
                Object.keys(propertiesGroup).forEach(key => {
                    let largeItemValue = ''
                    let largeItemAmount = 0
                    let details = []
                    // 一致する要素別
                    const keyGroup = `view_${heir.id}_${key}`
                    for (const property of propertiesGroup[key]) {
                        largeItemValue = property.large_item_value
                        let detail = mapedDetails[heir.id][property.id]
                        if (property.debt_flag) {
                            amount -= detail.amount
                            largeItemAmount -= detail.amount
                        } else {
                            amount += detail.amount
                            largeItemAmount += detail.amount
                        }
                        const id = `property_${property.id}_${heir.id}`
                            this.setViewMappingGroup(id, keyGroup)
                            details.push({
                                id: `property_${property.id}_${heir.id}`,
                                amount: detail.amount,
                                ratio: detail.ratio,
                                items_value: property.items_value,
                                section_value: property.section_value,
                                etc: property.etc,
                                debt_flag: property.debt_flag
                            })
                    }
                    largeItems.push({
                        key: keyGroup,
                        large_item_value: largeItemValue,
                        amount: largeItemAmount,
                        details
                    })
                })
                return { relationship: heir.relationship, name: heir.name, largeItems, amount }
            })
        },
        watchSimulationIdChange: function () {
            const member = this.simulationMemberId === 0 ? { id: 0, firstName: 'レガシィ' } : this.members.find(m => m.id === this.simulationMemberId)
            this.simulationMember = member || {}
        },
        setAmountAndPercent () {
            for (const propertyMap of this.simulationDetail.data) {
                this.$set(this.percent, `property_${propertyMap.property_id}_${propertyMap.heir_id}`, propertyMap.ratio)
                this.$set(this.amount, `property_${propertyMap.property_id}_${propertyMap.heir_id}`, propertyMap.amount)
            }
        },
        cancelSimulation () {
            if (this.simulationId === -1) {
                this.simulations.pop()
                this.simulationId = 0
            }
            this.showDivisionDetail(this.simulationId)
        },
        showTab: function (tab) {
            this.tab = tab
        },
        showTotalTab: function (tab) {
            this.tabTotal = tab
        },
        createInitialPlan: async function () {
            try {
                await DivisionSimulationApi.putDivisionSimulationDetail(this.ankenId, 0, { kintoneAnkenId: this.kintoneKintoneAnkenId, details: [], properties: this.kintonePropertiesMap, propertiesUpdatedAt: this.kintonePropertiesUpdatedAt, heirs: this.kintoneHeirsMap, heirsUpdatedAt: this.kintoneHeirsUpdatedAt, disclosure: [] })
                this.simulations.push({ 'id': 0, 'member_id': 0, 'disclosure': [] })
                this.showDivisionDetail(0)
            } catch (e) {
                if (e.response.status === 400 && e.response.data.message != null) {
                    this.errorMessageBox(e, e.response.data.message)
                } else {
                    this.errorMessageBox(e, '初回分割案の作成に失敗しました。')
                }
            }
        },
        complementDetailsDefault (srcDetails) {
            const mapedDetails = srcDetails.reduce((result, item) => {
                var heirs = result[item.heir_id] = result[item.heir_id] || {}
                heirs[item.property_id] = heirs[item.property_id] || item
                return result
            }, {})
            const details = []
            for (const prop of this.properties) {
                for (const heir of this.heirs) {
                    details.push(((mapedDetails[heir.id] || {})[prop.id]) || { 'property_id': +prop.id, 'heir_id': +heir.id, 'ratio': 0, 'amount': 0 })
                }
            }
            return details
        },
        saveSimulation: async function () {
            if (this.isEditAbleSimulation) {
                const warningAmount = Object.values(this.alertAmount).find(al => al.alert)
                if (warningAmount && (this.simulationId !== 0 || this.simulationDetail.data.find(s => s.amount !== 0))) {
                    this.showWarningAmount = true
                    this.scrollToWarningInput()
                    return
                }
               this.saveDivisionDetail(this.simulationId)
            }
        },
        setViewMappingGroup: function (view, groupKey) {
            if (!this.viewMappingGroup[view]) {
                this.viewMappingGroup[view] = []
            }
            if (this.viewMappingGroup[view].indexOf(groupKey) === -1) {
                this.viewMappingGroup[view].push(groupKey)
            }
        },
        clearView () {
            this.viewShowAssetHeir = {}
            this.viewShowIndividualLargeItem = {}
            this.showWarningAmount = false
            this.viewMappingGroup = {}
        },
        scrollToWarningInput () {
            const listKeyError = []
            Object.keys(this.alertAmount).forEach(alKey => {
                if (this.alertAmount[alKey].alert) {
                    const viewGroups = this.viewMappingGroup[alKey]
                    viewGroups.forEach(vg => {
                        this.$set(this.viewShowAssetHeir, vg, true)
                        this.$set(this.viewShowIndividualLargeItem, vg, true)
                    })
                    listKeyError.push(alKey)
                }
            })
            this.$nextTick(() => {
                const offsetTop = listKeyError.map(elmId => {
                    const elm = document.getElementById(elmId)
                    return elm ? elm.offsetTop : 0
                }).filter(offsetTop => offsetTop > 0)
                const scrollTop = Math.min(...offsetTop)
                if (scrollTop > 0) {
                    window.scroll(0, scrollTop - (this._$(window).width() > 600 ? 150 : 50))
                }
            })
        },
        handleSelectDivisionDetail (planId) {
            if (planId === this.simulationId) return
            if (this.isEditAbleSimulation) {
                this.$confirm('編集内容が破棄されます。よろしいですか？', {
                    confirmButtonText: '破棄する',
                    cancelButtonText: 'キャンセル',
                    type: 'warning',
                    showClose: false
                }).then(() => {
                    this.isEditAbleSimulation = false
                    if (this.simulationId === -1) this.simulations.pop()
                    this.showDivisionDetail(planId)
                })
            } else {
                this.showDivisionDetail(planId)
            }
        },
        moveToTotalTab: function () {
            this.scrollById('total-table-tabs')
        },
        getUpdateNotice: async function () {
            const resUpdateInfo = await UpdateNoticeApi.getUpdateNoticeDivisionInfo(this.ankenId, this.role)
            if (resUpdateInfo.status === 200) {
                let _this = this
                resUpdateInfo.data.data.forEach(function (id) {
                    _this.$set(_this.updateNoticePlanId, id, true)
                })
                this.$parent.isUpdateNotice = resUpdateInfo.data.data.length > 0
            }
        },
        editAbleSimulation () {
            if (!this.isEditAbleSimulation) {
                if (this.kintoneAnkenId !== this.kintoneKintoneAnkenId || this.heirsUpdatedAt !== this.kintoneHeirsUpdatedAt || this.propertiesUpdatedAt !== this.kintonePropertiesUpdatedAt) {
                    const cnvHeirIdMap = {}
                    const tmpHeirs = _.cloneDeep(this.heirs)
                    this.kintoneHeirs.forEach(kintoneHeir => {
                        for (var idx = 0; idx < tmpHeirs.length; idx++) {
                            const tmpHeir = tmpHeirs[idx]
                            if (kintoneHeir.name === tmpHeir.name && kintoneHeir.relationship === tmpHeir.relationship) {
                                cnvHeirIdMap[tmpHeir.id] = kintoneHeir.id
                                tmpHeirs.splice(idx, 1)
                                break
                            }
                        }
                    })
                    const cnvPropertyIdMap = {}
                    const tmpProperties = _.cloneDeep(this.properties)
                    this.kintoneProperties.forEach(kintoneProperty => {
                        for (var idx = 0; idx < tmpProperties.length; idx++) {
                            const tmpProperty = tmpProperties[idx]
                            if (kintoneProperty.large_item_value === tmpProperty.large_item_value &&
                                kintoneProperty.items_value === tmpProperty.items_value &&
                                kintoneProperty.section_value === tmpProperty.section_value &&
                                kintoneProperty.etc === tmpProperty.etc &&
                                kintoneProperty.amount === tmpProperty.amount) {
                                cnvPropertyIdMap[tmpProperty.id] = kintoneProperty.id
                                tmpProperties.splice(idx, 1)
                                break
                            }
                        }
                    })
                    const cnvDetails = []
                    this.simulationDetail.data.forEach(detail => {
                        const heirId = cnvHeirIdMap[detail.heir_id]
                        const propertyId = cnvPropertyIdMap[detail.property_id]
                        if (heirId && propertyId) {
                            cnvDetails.push({ 'property_id': propertyId, 'heir_id': heirId, 'ratio': detail.ratio, 'amount': detail.amount })
                        }
                    })
                    this.kintoneAnkenId = this.kintoneKintoneAnkenId
                    this.heirsMap = this.kintoneHeirsMap
                    this.heirsUpdatedAt = this.kintoneHeirsUpdatedAt
                    this.heirs = this.kintoneHeirs
                    this.propertiesMap = this.kintonePropertiesMap
                    this.propertiesUpdatedAt = this.kintonePropertiesUpdatedAt
                    this.properties = this.kintoneProperties
                    this.simulationDetail.data = this.complementDetailsDefault(cnvDetails)
                    this.clearView()
                }
                this.$nextTick(function () {
                    this.simulationIndividualTypeDetail.forEach((classification, ai) => {
                        this.heirs.forEach(heir => {
                            this.$set(this.classificationPercent, `${ai}`, false)
                            this.$set(this.classificationPercent, `${ai}_${heir.id}`, 0)
                        })
                    })
                })
                this.isEditAbleSimulation = true
            }
        },
        changeInputClassificationPercent (value, ai, id) {
            // check if value if greater than 100
            value = Math.min(value, 100)
            this.$set(this.classificationPercent, `${ai}_${id}`, value)
        },
        setIndividualPercent (ai) {
            const individual = this.simulationIndividualTypeDetail[ai]
            individual.items.forEach(item => {
                this.heirs.forEach(heir => {
                    const percent = this.classificationPercent[`${ai}_${heir.id}`]
                    if (percent !== '') this.changeInputPercent(percent, item.key + '_' + heir.id)
                })
            })
            this.classificationPercent[ai] = false
        },
        handleDownload: function () {
            try {
                let downloadData = []
                let header = {
                    group_name: '財産/債務',
                    detail_name: '科目',
                    amount: '総額'
                }
                this.heirs.forEach((heir, index) => {
                    const preFix = 'heir_' + (index + 1) + '_'
                    header[preFix + 'name'] = '相続人' + (index + 1)
                    header[preFix + 'ratio'] = 'パーセンテージ'
                    header[preFix + 'amount'] = '金額'
                })
                downloadData.push(header)
                this.simulationIndividualTypeDetail.forEach(individual => {
                    individual.items.forEach(item => {
                        let detailName = item.section_value.trim()
                        if (item.items_value) detailName += ' ' + item.items_value.trim()
                        if (item.etc) detailName += ' ' + item.etc.trim()
                        let data = {
                            group_name: individual.name,
                            detail_name: detailName,
                            amount: item.amount
                        }
                        item.heirsDetail.forEach((heir, index) => {
                            const preFix = 'heir_' + (index + 1) + '_'
                            data[preFix + 'name'] = heir.name
                            data[preFix + 'ratio'] = heir.ratio + '%'
                            data[preFix + 'amount'] = heir.debt_flag ? -heir.amount : heir.amount
                        })
                        downloadData.push(data)
                    })
                })
                let blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), Papa.unparse(downloadData, { header: false })], { type: 'text/csv;charset=utf-8;' })
                let link = document.createElement('a')
                let url = URL.createObjectURL(blob)
                link.setAttribute('href', url)
                link.setAttribute('download', 'heritage-division-' + this.ankenId + '-' + (this.simulationId === -1 ? 'new' : this.simulationId) + '.csv')
                link.style.visibility = 'hidden'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            } catch (e) {
                this.$alert(e.message, 'エラー', {
                    confirmButtonText: 'OK',
                    type: 'error',
                    center: true
                })
            }
        },
        percentDiv: function (value, total) {
            if (!value || !total || total === 0) return 0
            return Math.floor(value / total * 100)
        },
        scrollDetail: function (type, ai, name) {
            const scrollTab = type === 'asset' ? 'by_asset' : 'by_individual'
            if (this.tab !== scrollTab) this.tab = scrollTab
            this.$nextTick(function () {
                this.scrollById(type + '_' + ai + '_' + name)
            })
        },
        scrollById: function (id) {
            const elm = document.getElementById(id)
            if (elm) {
                const bodyRect = document.body.getBoundingClientRect()
                const clientRect = elm.getBoundingClientRect()
                var navHeight = 0
                const navViews = document.getElementsByClassName('img-logo')
                if (navViews.length > 0) {
                    const navView = navViews[0]
                    if (navView && this._$(navView).css('position') === 'fixed') {
                        navHeight = navView.offsetHeight
                    }
                }
                const scrollTop = clientRect.top - bodyRect.top - navHeight
                window.scroll(0, scrollTop)
            }
        }
    },
    computed: {
        ...mapGetters(['currentUser']),
        divisionGeneral () {
            return this.heirs.map(heir => {
                let inheritance = 0
                let dept = 0
                let asset = 0
                this.simulationDetail.data.filter((detail) => { return +detail.heir_id === +heir.id }).forEach((detail) => {
                    let isDebt = this.propertiesMap[detail.property_id].debt_flag
                    inheritance += (isDebt ? -1 * detail.amount : detail.amount)
                    dept -= (isDebt ? detail.amount : 0)
                    asset += (!isDebt ? detail.amount : 0)
                })
                return { ...heir, inheritance, dept, asset }
            })
        },
        totalInheritance () {
            return this.properties.reduce((total, prop) => {
                if (prop.debt_flag) {
                  return total - prop.amount
                }
                return total + prop.amount
            }, 0)
        },
        totalDept () {
            return this.properties.reduce((total, prop) => {
                return total - (prop.debt_flag ? prop.amount : 0)
            }, 0)
        },
        totalAsset () {
            return this.properties.reduce((total, prop) => {
                return total + (!prop.debt_flag ? prop.amount : 0)
            }, 0)
        },
        isDivisionDetailOwner () {
            return (this.role === 'client' && this.currentUser.id === this.simulationMemberId) ||
            (this.role === 'admin' && this.simulationMemberId === 0)
        },
        canAddDivisionDetail () { return this.totalRecords < 11 },
        hasDivisionDetail () { return this.simulations.length > 0 },
        hasKintone () { return Object.keys(this.kintonePropertiesMap).length > 0 && Object.keys(this.kintoneHeirsMap).length > 0 },
        alertAmount () {
            const alertAmountObj = {}
            const simulationGroup = _.groupBy(this.simulationDetail.data, 'property_id')
            Object.keys(simulationGroup).forEach(propertyId => {
                const simulations = simulationGroup[propertyId]
                const totalSimulationAmount = simulations.reduce((total, s) => {
                    return total + s.amount
                }, 0)
                const property = this.properties.find(p => +p.id === +propertyId)
                simulations.forEach(s => {
                    alertAmountObj[`property_${s.property_id}_${s.heir_id}`] = {
                        alert: +totalSimulationAmount !== +property.amount,
                        large_item_value: property.large_item_value
                    }
                })
            })
            return alertAmountObj
        },
        disableByPerm () {
            if (this.anken.length !== 0) {
                if (this.role === 'admin') {
                    return ((this.anken.completed && !this.$perm.has('C04-03')) || (!this.anken.completed && !this.$perm.has('C04-02')))
                } else {
                    return this.anken.completed
                }
            }
            return false
        }
    },
    watch: {
        properties: {
            handler: function () {
                this.setAmountAndPercent()
            },
            deep: true
        },
        'simulationDetail.data': {
            handler: function () {
                this.makeSimulationIndividualTypeDetail()
                this.makeSimulationAssetTypeDetail()
                this.setAmountAndPercent()
                this.$nextTick(function () {
                    this.$parent.isLoaded = true
                })
            },
            deep: true
        },
        heirs: {
            handler: function () {
                this.setAmountAndPercent()
            },
            deep: true
        },
        simulationId: function () {
            this.watchSimulationIdChange()
        }
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                return moment(value).format('YYYY[年]MM[月]DD[日]')
            }
        },
        numberWithDebt: function (x) {
          const abs = Math.abs(x)
          const commas = abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return +x >= 0 ? ' ' + commas : '▲  ' + commas
        },
        numberWithCommas: function (x) {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
    }
}
</script>
<style scoped>
@import "../../../../assets/css/custom.css";
/****************************************
parts
*****************************************/
/*border-box*/
.border-box{
    background: #fff;
    border: 2px solid #c0b283;
    padding: 1em;
}
/*btn*/
.btn{
    background: #999;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-weight: bold;
    padding: .5em 1em;
    text-align: center;
}
.btn-white{
    background: #fff;
    border: 1px solid #c0b283;
    color: #321007;
}
.btn-red{
    background: #a5272a;
}
.btn-green{
    background: #32b16c;
}

.btn-more{
    background: #a5272a;
}
.btn-more i{
    margin-left: 1em;
}
.btn-login{
    align-items: center;
    background: #887861;
    display: flex;
    margin-right: .5em;
}
@media screen and (max-width:768px){
    .btn-login,
    .btn-menu{
        font-size: 12px;
    }
    .btn-menu{
        background: #a5272a;
    }
    .btn-menu i{
        font-size: 2em;
    }
}

/*image*/
.fit-img{
    height: auto;
    width: 100%;
}
.fit-max-img{
    height: auto;
    max-width: 100%;
}
/*tab*/
.tab-btn{
    background: #fff;
    border: 1px solid #c0b283;
    border-radius:5px 5px 0px 0px ;
    font-size: .8em;
    padding: .5em 2em;
  cursor: pointer;
}
.tab-btn.current{
    background: #f7f0df;
}
@media screen and (max-width:400px){
    .tab-btn{
        padding: .5em 1em;
    }
}

/*table*/
.table{
    background: #fff;
    border-top: 2px solid #c0b283;
    width: 100%;
}
.table th,
.table td{
  background: #fffdf7;
  border-left: 2px solid #c0b283;
  border-bottom: 2px solid #c0b283;
    border-right: 2px solid #c0b283;
    padding: 1em;
}
.table th{
    background: #f7f0df;
    font-weight: bold;
    text-align: left;
}

.table td{
    vertical-align: top;
}
.table td.transparent{
    background: transparent;
}
.table-scroll-wrap{
    position: relative;
}
.table-scroll{
    overflow-x:scroll;
    white-space: nowrap;
}
.table-overlay{
    left: 0;
    position:absolute;
    top: 0;
    width: auto;
    table-layout: fixed;
    border-collapse: collapse;
    white-space: nowrap;

}
/*title*/
.title-label{
    background: #321007;
    color: #fff;
    font-size: 1.5em;
    font-weight: bold;
    padding: .5em 0;
    text-align: center;
}
.title-label .table{
    width: auto;
}
.isan-btns a {
    margin-left: 15px;
}
.text-center{
    text-align: center!important;
}
.text-left{
    text-align: left!important;
}
.text-right{
    text-align: right!important;
}
.tategaki{
    writing-mode:vertical-rl;
}
.pl2 {
  padding-left: 2rem!important;
}
.cursor-pointer {
  cursor: pointer;
}
#heritage-division .el-input__inner {
  text-align: right;
  font-size: large;
  color: black;
}

#heritage-division .el-input.is-disabled .el-input__inner {
  background-color: white !important;
  cursor: text;
  border: none;
  color: black;
}
#heritage-division button[disabled].btn__default.mr1.el-button {
    background: #8a0602 !important;
    color: white !important;
    font-weight: bold!important;
}

#heritage-division .ml-auto {
  margin-left: auto !important;
}
.heritage-division button:disabled {
    cursor: not-allowed;
}
.division-button .el-button {
    background: #8a0602 !important;
    color: white !important;
    font-weight: bold!important;
}
.div-update-notice {
    display:inline-block;
    position: relative;
}
.img-update-notice {
    position: absolute;
    left:0px;
    top:-5px;
}
.img-update-notice-none {
    display:none;
}
button.margin {
    margin-right: 1em;
    margin-bottom: 5px;
}
a.scroll {
    color: red;
    font-weight: bold;
    text-decoration: underline !important;
}
_:-ms-lang(x)::-ms-backdrop, table {
    table-layout: fixed;
}
.cell-percent .percent {
    margin-right: 2px;
}
</style>
